<audio #audioPlayer controls controlsList="nodownload" [className]="audioClass" id="content-audio-{{audioAssetId}}"
  [src]="primaryUrl" type="audio/mp3" [preload]="preload" (error)="onErrorFuncAllowed && primaryUrl!== '' && fetchAudioUrl(true)" oncontextmenu="return false;">
  Your browser doesn't support audio playback.
</audio>